import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SystemCapabilities } from 'adc-sirius-module-common';

export const initialState: SystemCapabilities = {
  canGetStudyData: false,
  canGetStudies: false,
  canGetOrganizations: false,
  canInsertOrganizations: false,
  canInsertUsers: false,
  canGetUsers: false,
  canInsertAssignments: false,
  canGetAssignments: false,
};

export const capabilitiesSlice = createSlice({
  name: 'capabilities',
  initialState,
  reducers: {
    setCapabilities: (_state, action: PayloadAction<SystemCapabilities>) => {
      return {
        ...initialState,
        ...action.payload,
      };
    },
  },
});

export const { setCapabilities } = capabilitiesSlice.actions;
export default capabilitiesSlice.reducer;
